<div class="p-3 pt-2 rounded-4">
  <div>
    <div class="pTitle border-0 mb-0 rounded-bottom-0 rounded-4 p-0 d-flex justify-content-between">
      <div class="p-3">Provider</div>
      <button class="btn btn-info btn-sm bg-white me-3 mt-3 mb-3" (click)="addNew()">Add New</button>
    </div>
  </div>
  <div class="container-fluid">
    <div class="row bg-white p-2 pt-0">
      <div class="col-md-12 mt-4 mb-5">
        <div class="table-responsive">
          <ag-grid-angular style="width: 100%; height: 600px" class="ag-theme-alpine"
            [columnDefs]="columnDefs" [gridOptions]="gridOptions" (gridReady)="onGridReady($event)">
          </ag-grid-angular>
        </div>
      </div>
    </div>
  </div>
</div>

{{ setContent(content) }}

<ng-template #content let-modal>
  <div class="modal-header">
    <h4 class="modal-title" id="modal-basic-title">{{ dataObj._id ? 'Edit' : 'Add New' }} Provider</h4>
    <button type="button" class="btn-close" aria-label="Close" (click)="onClose()"></button>
  </div>
  <div class="modal-body">
    <form #providerForm="ngForm">
      <div class="container-fluid">
        <div class="row">
          <div class="col-md-6">
            <div class="form-group">
              <label class="required">Provider Name</label>
              <input type="text" class="form-control" required name="providerName" #providerName="ngModel"
                [(ngModel)]="dataObj.providerName" required>
            </div>
            @if (providerName.touched && providerName.invalid) {
              <div class="text-danger">
                Please enter the provider name
              </div>
            }
          </div>
          <div class="col-md-6">
            <div class="form-group">
              <label class="required">Provider Type</label>
              <select class="form-control form-select" required name="providerType" #providerType="ngModel"
                [(ngModel)]="dataObj.providerType" required>
                <option value="">Select Type</option>
                <option value="SMS">SMS</option>
                <option value="EMAIL">Email</option>
              </select>
            </div>
            @if (providerType.touched && providerType.invalid) {
              <div class="text-danger">
                Please select provider type
              </div>
            }
          </div>
        </div>

        <div class="row">
          <div class="col-md-6">
            <div class="form-group">
              <label>Country</label>
              <select class="form-control form-select" name="countryCode" #countryCode="ngModel"
                [(ngModel)]="dataObj.countryCode">
                <option value="">Global Provider</option>
                @for (country of countries; track country) {
                  <option [value]="country.country_code">
                    {{ country.displayName }}
                  </option>
                }
              </select>
            </div>
          </div>
          <div class="col-md-6">
            <div class="form-group">
              <label>Priority</label>
              <input type="number" class="form-control" name="priority" #priority="ngModel"
                [(ngModel)]="dataObj.priority" min="1" max="10">
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-md-6 mt-3">
            <div class="form-check">
              <input class="form-check-input" type="checkbox" [value]="dataObj.isActive" id="isActive" [(ngModel)]="dataObj.isActive">
              <label class="form-check-label" for="isActive">
                Active
              </label>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-md-12">
            <div class="form-group">
              <label>Configuration (JSON)</label>
              <textarea class="form-control" rows="5" name="config" #config="ngModel"
              [(ngModel)]="dataObj.config" placeholder='{"apiKey": "your-api-key", "senderEmail": "email@example.com"}'></textarea>
              <div class="form-text">Enter provider-specific configuration in JSON format</div>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-md-12 mt-2 text-center">
            <button [disabled]="!providerForm.valid" class="btn btn-primary active mt-4 w-50"
            (click)="onSubmit(providerForm.valid)">Submit</button>
          </div>
        </div>
      </div>
    </form>
  </div>
</ng-template>